import fetch from '@ixigo/fetch';

export const validateIntlPhone = async (payload: {
	mobile: number;
	countryCode: string;
}) => {
	const url = 'api/v2/users/mobile/verify';
	const body = `mobile=${encodeURIComponent(payload.mobile)}&countryCode=${encodeURIComponent(payload.countryCode)}`;

	const response = await fetch
		.post<{ data: { isValid: boolean } }>(url, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body,
		})
		.json();

	if (response?.data) {
		return response.data;
	}
	return null;
};

export const isEmailValid = async (email: string) => {
	const url = 'flight-booking/email/validate';
	const response = await fetch
		.post<{ data: { success: boolean } }>(url, {
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ email }),
		})
		.json();
	return response?.data?.success ?? false;
};
